import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const PoiShopIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M6.867 3.667V2.867C6.867 2.37184 6.6703 1.89696 6.32017 1.54683C5.97004 1.1967 5.49516 1 5 1C4.50484 1 4.02996 1.1967 3.67983 1.54683C3.3297 1.89696 3.133 2.37184 3.133 2.867V3.667H1V9H9V3.667H6.867ZM3.667 2.867C3.667 2.69195 3.70148 2.51861 3.76847 2.35688C3.83546 2.19516 3.93365 2.04821 4.05743 1.92443C4.18121 1.80065 4.32816 1.70246 4.48988 1.63547C4.65161 1.56848 4.82495 1.534 5 1.534C5.17505 1.534 5.34839 1.56848 5.51012 1.63547C5.67184 1.70246 5.81879 1.80065 5.94257 1.92443C6.06635 2.04821 6.16454 2.19516 6.23153 2.35688C6.29852 2.51861 6.333 2.69195 6.333 2.867V3.667H3.667V2.867ZM8.467 8.467H1.533V4.2H3.133V5.267H3.667V4.2H6.333V5.267H6.867V4.2H8.467V8.467Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const PoiShopIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M6.867 3.667V2.867C6.867 2.37184 6.6703 1.89696 6.32017 1.54683C5.97004 1.1967 5.49516 1 5 1C4.50484 1 4.02996 1.1967 3.67983 1.54683C3.3297 1.89696 3.133 2.37184 3.133 2.867V3.667H1V9H9V3.667H6.867ZM3.667 2.867C3.667 2.69195 3.70148 2.51861 3.76847 2.35688C3.83546 2.19516 3.93365 2.04821 4.05743 1.92443C4.18121 1.80065 4.32816 1.70246 4.48988 1.63547C4.65161 1.56848 4.82495 1.534 5 1.534C5.17505 1.534 5.34839 1.56848 5.51012 1.63547C5.67184 1.70246 5.81879 1.80065 5.94257 1.92443C6.06635 2.04821 6.16454 2.19516 6.23153 2.35688C6.29852 2.51861 6.333 2.69195 6.333 2.867V3.667H3.667V2.867ZM8.467 8.467H1.533V4.2H3.133V5.267H3.667V4.2H6.333V5.267H6.867V4.2H8.467V8.467Z" />
        </SvgIcon>
    );
};
